document.addEventListener("DOMContentLoaded", () => {

    const container =
        document.getElementById("quote-items");

    const empty =
        document.getElementById("quote-empty");

    const enquiryForm =
        document.getElementById("quote-enquiry");


    if (!container) return;


    /* ==========================================================
       RENDER BASKET
    ========================================================== */

    function renderBasket() {

        const items = Quote.get();


        if (items.length === 0) {

            container.innerHTML = "";

            empty.style.display = "block";

            if (enquiryForm) {
                enquiryForm.hidden = true;
            }

            return;
        }


        empty.style.display = "none";


        if (enquiryForm) {
            enquiryForm.hidden = false;
        }


        let html = "";


        items.forEach(item => {


            /*
             * Only show Variant when a variant exists.
             */
            const variantHtml =
                item.variantTitle &&
                item.variantTitle !== "Default Title"

                    ? `
                        <p>
                            <strong>Variant:</strong>
                            ${item.variantTitle}
                        </p>
                      `

                    : "";


            html += `

<div class="quote-item">

    <div class="quote-image">

        <img
            src="${item.image}"
            alt="${item.title}"
        >

    </div>


    <div class="quote-content">

        <h3>${item.title}</h3>


        ${variantHtml}


        <div class="quote-quantity">

            <button
                class="quote-minus"
                data-id="${item.id}"
                type="button"
            >
                −
            </button>


            <span>
                ${item.quantity}
            </span>


            <button
                class="quote-plus"
                data-id="${item.id}"
                type="button"
            >
                +
            </button>

        </div>


        <div class="quote-links">

            <a href="${item.url}">
                View Product
            </a>


            <button
                class="quote-remove"
                data-id="${item.id}"
                type="button"
            >
                Remove
            </button>

        </div>

    </div>

</div>

`;

        });


        html += `

<div class="quote-footer">

    <button
        id="clear-quote"
        class="quote-clear-btn"
        type="button"
    >
        Clear Basket
    </button>

</div>

`;


        container.innerHTML = html;

    }


    renderBasket();


    /* ==========================================================
       FORM SUBMIT
    ========================================================== */

    if (enquiryForm) {

        enquiryForm.addEventListener(
            "submit",
            function (event) {

                event.preventDefault();

                submitQuote();

            }
        );

    }


    /* ==========================================================
       BASKET ACTIONS
    ========================================================== */

    container.addEventListener(
        "click",
        function (e) {


            /* ---------------- PLUS ---------------- */

            if (
                e.target.classList.contains(
                    "quote-plus"
                )
            ) {

                const id =
                    e.target.dataset.id;


                const item =
                    Quote.get().find(
                        item =>
                            String(item.id) ===
                            String(id)
                    );


                if (!item) return;


                Quote.updateQuantity(
                    id,
                    item.quantity + 1
                );


                renderBasket();

            }


            /* ---------------- MINUS ---------------- */

            if (
                e.target.classList.contains(
                    "quote-minus"
                )
            ) {

                const id =
                    e.target.dataset.id;


                const item =
                    Quote.get().find(
                        item =>
                            String(item.id) ===
                            String(id)
                    );


                if (!item) return;


                Quote.updateQuantity(
                    id,
                    item.quantity - 1
                );


                renderBasket();

            }


            /* ---------------- REMOVE ---------------- */

            if (
                e.target.classList.contains(
                    "quote-remove"
                )
            ) {

                const id =
                    e.target.dataset.id;


                Quote.remove(id);

                renderBasket();

            }


            /* ---------------- CLEAR ---------------- */

            if (
                e.target.id ===
                "clear-quote"
            ) {

                if (
                    confirm(
                        "Clear the entire Quote Basket?"
                    )
                ) {

                    Quote.clear();

                    renderBasket();

                }

            }


            /* ---------------- SUBMIT ---------------- */

            if (
                e.target.id ===
                "submit-quote"
            ) {

                submitQuote();

            }

        }
    );


    /* ==========================================================
       SUBMIT QUOTE
    ========================================================== */

    function submitQuote() {

        const customer = {

            name:
                document
                    .getElementById("quote-name")
                    .value
                    .trim(),

            company:
                document
                    .getElementById("quote-company")
                    .value
                    .trim(),

            email:
                document
                    .getElementById("quote-email")
                    .value
                    .trim(),

            phone:
                document
                    .getElementById("quote-phone")
                    .value
                    .trim(),

            location:
                document
                    .getElementById("quote-location")
                    .value
                    .trim(),

            notes:
                document
                    .getElementById("quote-notes")
                    .value
                    .trim()

        };


        /* ---------------- VALIDATION ---------------- */

        if (!customer.name) {

            alert("Please enter your name.");

            return;

        }


        if (!customer.email) {

            alert("Please enter your email.");

            return;

        }


        if (!customer.phone) {

            alert("Please enter your phone number.");

            return;

        }


        const items = Quote.get();


        /* ======================================================
           WHATSAPP MESSAGE
        ====================================================== */

        let message =
            `*New B2B Quote Enquiry*\n\n`;


        message +=
            `*Customer Details*\n`;

        message +=
            `Name: ${customer.name}\n`;

        message +=
            `Company: ${customer.company || "-"}\n`;

        message +=
            `Email: ${customer.email}\n`;

        message +=
            `Phone: ${customer.phone}\n`;

        message +=
            `Location: ${customer.location || "-"}\n`;


        message +=
            `\n------------------------\n`;

        message +=
            `*Products*\n\n`;


        /* ======================================================
           PRODUCTS
        ====================================================== */

        items.forEach((item, index) => {

            message +=
                `${index + 1}. *${item.title}*\n`;


            /*
             * Show selected variant.
             */
            if (
                item.variantTitle &&
                item.variantTitle !==
                    "Default Title"
            ) {

                message +=
                    `Variant: ${item.variantTitle}\n`;

            }


            message +=
                `Qty: ${item.quantity}\n`;


            message +=
                `Product: ${window.location.origin}${item.url}\n\n`;

        });


        /* ---------------- NOTES ---------------- */

        if (customer.notes) {

            message +=
                `------------------------\n`;

            message +=
                `*Additional Notes*\n`;

            message +=
                `${customer.notes}\n`;

        }


        /* ---------------- WHATSAPP ---------------- */

        const whatsappUrl =
            "https://wa.me/" +
            window.theme.whatsappNumber +
            "?text=" +
            encodeURIComponent(message);


        window.open(
            whatsappUrl,
            "_blank"
        );

    }

});